export default __webpack_public_path__ + "static/media/wallpaper.736cbec9.svg";